import { Icon } from '@iconify/react';
import userAddOutlined from '@iconify/icons-ant-design/user-add-outlined';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    boxShadow: 'none',
    textAlign: 'center',
    padding: theme.spacing(5, 0),
    color: theme.palette.info.darker,
    backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
    margin: 'auto',
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    width: theme.spacing(8),
    height: theme.spacing(8),
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    color: theme.palette.info.dark,
    backgroundImage: `linear-gradient(135deg, ${alpha(
        theme.palette.info.dark,
        0
    )} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`
}));

// ----------------------------------------------------------------------

// const TOTAL = 3;

export default function AppNewUsers({ patients }) {
    const total = patients.length;
    return (
        <RootStyle>
            <IconWrapperStyle>
                <Icon icon={userAddOutlined} width={24} height={24} />
            </IconWrapperStyle>
            <Typography variant="h3">{fShortenNumber(total)}</Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
                Pacientes
            </Typography>
        </RootStyle>
    );
}
